<template>
	<span class="rose-cross" aria-hidden="true"><img :src="closeRose" alt="" width="20.4" height="20.4" /></span>
</template>

<script setup lang="ts">
// The Kova "icon-close" of the cancel frames (Figma 7415:17771, 7415:16355): a #cb3152 plus with a gap in
// its lower arm, turned 45° inside a 24px box. The DS `ds_kova_close` is a heavier, larger cross.
import closeRose from '@/assets/icons/close-rose.svg'
</script>

<style scoped>
.rose-cross {
	display: inline-flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;
	width: var(--size-24);
	height: var(--size-24);
}

.rose-cross img {
	transform: rotate(45deg);
}
</style>
